<template>
  <v-container grid-list-sm fluid>
    <v-layout row wrap>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoVacio :titulo="titulo" />
          <v-card-text>
            <v-form ref="form1">
              <v-layout row wrap>
                <v-flex text-right>
                  <v-chip small color="error">
                    {{ subtituloCompleto }}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md5>
                  <SelectProveedor
                    :model="itemActivo.Id_Proveedor"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarProveedor"
                  />
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <SelectTipoComprobanteNumeroRecibido
                    nombreModulo="[COMPRA]"
                    :id_PuntoVenta="appId_PuntoVenta"
                    :letra="itemActivo.Letra"
                    :numero="itemActivo.Numero"
                    :rules="[rules.requerido]"
                    @seleccionarTipoComprobante="seleccionarTipoComprobante"
                    @seleccionarCondicionVenta="seleccionarCondicionVenta"
                  />
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout row wrap>
              <v-flex xs12 md7>
                <Grilla
                  :columnas="grillaHeaders_Articulos"
                  :itemsDB="itemActivo.Articulos"
                  :loading="loading"
                  :sinAccionEditar="true"
                  @borrarItem="grillaBorrarItem_Articulos"
                />
              </v-flex>
              <v-flex xs12 md4 offset-md1>
                <Grilla
                  :columnas="grillaHeaders_Pagos"
                  :itemsDB="itemActivo.Pagos"
                  :loading="loading"
                  :sinAccionEditar="true"
                  @borrarItem="grillaBorrarItem_Pagos"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pt-3">
              <v-flex xs12 md6>
                <NavBarArticulo
                  v-if="!esOrdenPago"
                  :id_PuntoVenta="appId_PuntoVenta"
                  @seleccionarItem="seleccionarTecla"
                />
              </v-flex>
              <v-flex xs12 md1>
                <v-btn
                  v-if="!esOrdenPago"
                  rounded
                  block
                  color="primary"
                  @click="modalArticuloEjecutarAccion('Mostrar')"
                >
                  Buscar
                  <v-icon right>shopping_cart</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 md4 offset-md1 v-if="esVentaContado || esOrdenPago">
                <v-btn
                  small
                  rounded
                  class="ma-1"
                  @click="seleccionarTipoPago($nombreTipoPago_ChequePropio)"
                >
                  Cheque
                  <v-icon right>local_atm</v-icon>
                </v-btn>
                <v-btn
                  small
                  rounded
                  class="ma-1"
                  @click="seleccionarTipoPago($nombreTipoPago_Transferencia)"
                >
                  Transferencia
                  <v-icon right>account_balance</v-icon>
                </v-btn>
                <v-btn
                  rounded
                  color="primary"
                  class="ma-1"
                  @click="seleccionarTipoPago($nombreTipoPago_Efectivo)"
                >
                  Efectivo
                  <v-icon right>attach_money</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pt-3">
              <v-flex xs6 md1>
                <Importe
                  label="Gravado"
                  :model="itemActivo.Gravado"
                  @seleccionarItem="item => (itemActivo.Gravado = item.Importe)"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  :label="tituloIvaBasico"
                  :model="itemActivo.IvaBasico"
                  @seleccionarItem="
                    item => (itemActivo.IvaBasico = item.Importe)
                  "
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  :label="tituloIvaDiferencial"
                  :model="itemActivo.IvaDiferencial"
                  @seleccionarItem="
                    item => (itemActivo.IvaDiferencial = item.Importe)
                  "
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Exento"
                  :model="itemActivo.Exento"
                  @seleccionarItem="item => (itemActivo.Exento = item.Importe)"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Impuesto Interno"
                  :model="itemActivo.ImpuestoInterno"
                  @seleccionarItem="
                    item => (itemActivo.ImpuestoInterno = item.Importe)
                  "
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Tasa A"
                  :model="itemActivo.TasaA"
                  @seleccionarItem="item => (itemActivo.TasaA = item.Importe)"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Percepción IIBB"
                  :model="itemActivo.PercepcionIb"
                  @seleccionarItem="
                    item => (itemActivo.PercepcionIb = item.Importe)
                  "
                />
              </v-flex>
              <v-flex xs4 md2 offset-md3>
                <Importe
                  label="Total*"
                  :model="itemActivo.Total"
                  :rules="[rules.requerido]"
                  @seleccionarItem="item => (itemActivo.Total = item.Importe)"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md7>
                <v-text-field
                  ref="controlFocoNota"
                  label="Notas"
                  v-model="itemActivo.Nota"
                  :rules="[rules.maximo500]"
                  @keyup.enter="finalizar"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4 offset-md1 class="text-right">
                <v-btn
                  small
                  rounded
                  class="ma-1"
                  @click="ejecutarAccion('Inicializar')"
                >
                  Cancelar
                  <v-icon right>close</v-icon>
                </v-btn>
                <v-btn rounded color="primary" class="ma-1" @click="finalizar">
                  Finalizar
                  <v-icon right>done</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <ModalArticulo
      :activo="modalArticuloActivo"
      :id_Articulo="itemActivo.Id_Articulo"
      :nombreModulo="itemActivo.NombreModulo"
      :esVentaContado="esVentaContado"
      @ejecutarAccion="modalArticuloEjecutarAccion"
    />
    <ModalTipoPagoEfectivo
      :activo="modalTipoPagoEfectivoActivo"
      :comprobante="iResumenComprobante"
      :importe="itemActivo.TotalPagoPendiente"
      @ejecutarAccion="modalTipoPagoEfectivoEjecutarAccion"
    />
    <ModalTipoPagoChequePropio
      :activo="modalTipoPagoChequePropio"
      :comprobante="iResumenComprobante"
      :importe="itemActivo.TotalPagoPendiente"
      :destinatario="itemActivo.RazonSocial"
      @ejecutarAccion="modalTipoPagoChequePropioEjecutarAccion"
    />
    <ModalTipoPagoTransferencia
      :activo="modalTipoPagoTransferenciaActivo"
      :comprobante="iResumenComprobante"
      :importe="itemActivo.TotalPagoPendiente"
      @ejecutarAccion="modalTipoPagoTransferenciaEjecutarAccion"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
    <v-snackbar
      v-model="snackActivo"
      color="success"
      :timeout="3000"
      :vertical="true"
      >Generando el comprobante...
    </v-snackbar>
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import moment from "moment";
import { eventBus } from "@/main";
import EncabezadoVacio from "@/components/EncabezadoVacio";
import PieCrud from "@/components/PieCrud";
import Grilla from "@/components/Grilla";
import Mensaje from "@/components/Mensaje";
import Importe from "@/components/Importe";
import SelectTipoComprobanteNumeroRecibido from "@/components/Sistema/SelectTipoComprobanteNumeroRecibido";
import SelectProveedor from "@/components/Compra/SelectProveedor";
import NavBarArticulo from "@/components/Stock/NavBarArticulo";
import ModalArticulo from "@/components/Stock/ModalArticulo";
import ModalTipoPagoEfectivo from "@/components/Caja/ModalTipoPagoEfectivo";
import ModalTipoPagoChequePropio from "@/components/Banco/ModalTipoPagoChequePropio";
import ModalTipoPagoTransferencia from "@/components/Caja/ModalTipoPagoTransferencia";
export default {
  name: "Compra",
  components: {
    EncabezadoVacio,
    PieCrud,
    Grilla,
    Mensaje,
    Importe,
    SelectTipoComprobanteNumeroRecibido,
    SelectProveedor,
    NavBarArticulo,
    ModalArticulo,
    ModalTipoPagoEfectivo,
    ModalTipoPagoChequePropio,
    ModalTipoPagoTransferencia
  },
  data() {
    return {
      titulo: "Carga de Compras",
      subtitulo: "Caja Nº ",
      itemVacio: {
        NombrePuntoVenta: "",
        NombreModulo: "",
        Id_TipoComprobante: 0,
        NombreTipoComprobante: "",
        Id_CondicionVenta: 0,
        NombreCondicionVenta: "",
        Id_Talonario: 0,
        Letra: "",
        Numero: "",
        Fecha: "",
        Id_Proveedor: 0,
        RazonSocial: "",
        Id_TipoIva: "",
        Cuit: "",
        Id_Articulo: 0,
        Total: 0,
        Gravado: 0,
        IvaBasico: 0,
        IvaDiferencial: 0,
        Exento: 0,
        ImpuestoInterno: 0,
        TasaA: 0,
        PercepcionIb: 0,
        TotalPago: 0,
        TotalPagoPendiente: 0,
        Nota: "",
        Articulos: [],
        Pagos: [],
        Id_Caja: 0,
        FechaCaja: "",
        TurnoCaja: 0,
        NombreEmpleadoCaja: ""
      },
      itemActivo: {},
      itemsTipoPago: [],
      rules: {
        requerido: v => !!v || "Requerido",
        maximo500: v => (v || "").length <= 500 || "Máximo 500 caracteres"
      },
      grillaHeaders_Articulos: [
        {
          text: "Artículo",
          value: "Nombre",
          width: "50%",
          sortable: false
        },
        { text: "Cantidad", value: "Cantidad", sortable: false },
        { text: "Precio", value: "Precio", mask: "esMoneda", sortable: false },
        {
          text: "Importe",
          value: "Importe",
          mask: "esMoneda",
          sortable: false
        }
      ],
      grillaHeaders_Pagos: [
        {
          text: "Pago",
          value: "NombreTipoPago",
          width: "50%",
          sortable: false
        },
        {
          text: "Importe",
          value: "Importe",
          mask: "esMoneda",
          sortable: false
        }
      ],
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: "",
      loading: false,
      snackActivo: false,
      modalArticuloActivo: false,
      modalTipoPagoEfectivoActivo: false,
      modalTipoPagoChequePropio: false,
      modalTipoPagoTransferenciaActivo: false
    };
  },
  computed: {
    appId_PuntoVenta() {
      return this.$store.state.appId_PuntoVenta;
    },
    sysId_TipoIva() {
      return this.$store.state.sysId_TipoIva;
    },
    sysAlicuotaIvaBasico() {
      return this.$store.state.sysAlicuotaIvaBasico;
    },
    sysAlicuotaIvaDiferencial() {
      return this.$store.state.sysAlicuotaIvaDiferencial;
    },
    subtituloCompleto() {
      return this.itemActivo.Id_Caja == undefined ||
        this.itemActivo.Id_Caja == 0
        ? this.subtitulo
        : this.subtitulo +
            this.itemActivo.Id_Caja +
            " " +
            moment(this.itemActivo.FechaCaja)
              .locale("es")
              .format("DD/MM/YYYY") +
            "-" +
            this.itemActivo.TurnoCaja +
            " " +
            this.itemActivo.NombreEmpleadoCaja;
    },
    tituloIvaBasico() {
      return "Iva " + this.sysAlicuotaIvaBasico + "%";
    },
    tituloIvaDiferencial() {
      return "Iva " + this.sysAlicuotaIvaDiferencial + "%";
    },
    esVentaContado() {
      return (
        this.itemActivo.NombreCondicionVenta ==
        this.$nombreCondicionVenta_Contado
      );
    },
    esOrdenPago() {
      return (
        this.itemActivo.NombreTipoComprobante ==
        this.$nombreTipoComprobante_OrdenPago
      );
    },
    iResumenComprobante() {
      return (
        this.itemActivo.NombreTipoComprobante +
        " Nº " +
        this.itemActivo.Numero +
        " " +
        this.itemActivo.NombreCondicionVenta +
        (this.itemActivo.RazonSocial
          ? " a " + this.itemActivo.RazonSocial
          : " a Consumidor Final")
      );
    }
  },
  mounted() {
    this.ejecutarAccion("Inicializar");
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Guardar":
          this.mostrarMensaje(
            true,
            "ConfirmacionGuardar",
            "¿Quiere guardar el comprobante?",
            this.iResumenComprobante
          );
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "CancelarAviso":
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.inicializar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      this.itemActivo.Articulos = [];
      this.itemActivo.Pagos = [];
      var promesa1 = new Promise(function(resolve) {
        eventBus.$emit("inicializarSelectProveedor");
        resolve();
      });
      var promesa2 = new Promise(function(resolve) {
        eventBus.$emit("inicializarSelectTipoComprobanteNumeroRecibido");
        resolve();
      });
      promesa1.then(() => {
        promesa2.then(() => {
          eventBus.$emit("setearFocoSelectProveedor");
        });
      });
    },
    seleccionarProveedor(item) {
      this.itemActivo.Id_Proveedor = item.Id_Proveedor;
      this.itemActivo.RazonSocial = item.RazonSocial;
      this.itemActivo.Id_TipoIva = item.Id_TipoIva;
      this.itemActivo.Cuit = item.Cuit;
      this.seleccionarLetra();
    },
    seleccionarLetra(letra) {
      if (letra == null || "ABC".includes(this.itemActivo.Letra)) {
        if (this.sysId_TipoIva == "I")
          this.itemActivo.Letra = this.itemActivo.Id_TipoIva == "I" ? "A" : "B";
        else this.itemActivo.Letra = "C";
      } else this.itemActivo.Letra = letra;
    },
    seleccionarTipoComprobante(item) {
      if (item.NombreModulo != null) {
        this.itemActivo.NombrePuntoVenta = item.NombrePuntoVenta;
        this.itemActivo.NombreModulo = item.NombreModulo;
        this.itemActivo.Id_TipoComprobante = item.Id_TipoComprobante;
        this.itemActivo.NombreTipoComprobante = item.NombreTipoComprobante;
        this.itemActivo.Id_Talonario = item.Id_Talonario;
        this.itemActivo.Numero = item.NumeroActual;
        this.itemActivo.Fecha = item.Fecha;
        this.itemActivo.Id_Caja = item.Id_Caja;
        this.itemActivo.FechaCaja = item.FechaCaja;
        this.itemActivo.TurnoCaja = item.TurnoCaja;
        this.itemActivo.NombreEmpleadoCaja = item.NombreEmpleadoCaja;
        this.seleccionarLetra(item.Letra);
        this.cargarTiposPago();
      }
    },
    cargarTiposPago() {
      this.itemsTipoPago = [];
      this.loading = true;
      HttpHelper.get("TipoPago/ListarPorModulo", {
        nombreModulo: this.itemActivo.NombreModulo
      })
        .then(response => {
          this.itemsTipoPago = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    seleccionarCondicionVenta(item) {
      this.itemActivo.Id_CondicionVenta = item.Id_CondicionVenta;
      this.itemActivo.NombreCondicionVenta = item.NombreCondicionVenta;
      if (!this.esVentaContado) {
        this.itemActivo.TotalPago = 0;
        this.itemActivo.Pagos = [];
      }
    },
    grillaBorrarItem_Articulos(item) {
      let ind = this.itemActivo.Articulos.findIndex(
        x => x.Id_Articulo == item.Id_Articulo
      );
      this.itemActivo.Articulos.splice(ind, 1);
      this.calcularTotal();
    },
    seleccionarTecla(item) {
      this.modalArticuloEjecutarAccion("Mostrar", item);
    },
    modalArticuloEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.itemActivo.Id_Articulo = item ? item.Id_Articulo : 0;
          this.modalArticuloActivo = true;
          break;
        case "Aceptar":
          this.agregarArticulo(item);
          this.modalArticuloActivo = false;
          break;
        case "Cerrar":
          this.modalArticuloActivo = false;
          break;
      }
    },
    agregarArticulo(item) {
      this.loading = true;
      if (item.Importe > 0) {
        let gravado = 0;
        let ivaBasico = 0;
        let ivaDiferencial = 0;
        let exento = 0;
        let impuestoInterno = 0;
        let tasaA = 0;
        let percepcionIb = 0;
        impuestoInterno = item.Cantidad * item.ImpuestoInternoArticulo;
        tasaA = item.Cantidad * item.TasaAArticulo;
        gravado = item.Importe - impuestoInterno - tasaA;
        if (item.Id_TipoIvaArticulo == this.$id_TipoIvaArticulo_Gravado) {
          gravado = gravado / (1 + this.sysAlicuotaIvaBasico / 100);
          ivaBasico = gravado * (this.sysAlicuotaIvaBasico / 100);
        } else {
          if (item.Id_TipoIvaArticulo == this.$id_TipoIvaArticulo_Diferencial) {
            gravado = gravado / (1 + this.sysAlicuotaIvaDiferencial / 100);
            ivaDiferencial = gravado * (this.sysAlicuotaIvaDiferencial / 100);
          } else {
            exento = gravado;
            gravado = 0;
          }
        }
        if (this.esDistribuidor)
          percepcionIb = gravado * (item.AlicuotaPercepcionIb / 100);
        this.itemActivo.Articulos.push({
          Id_Articulo: item.Id_Articulo,
          Nombre: item.NombreArticulo,
          Cantidad: item.Cantidad,
          Precio: item.Precio,
          Importe: item.Importe,
          Gravado: gravado,
          IvaBasico: ivaBasico,
          IvaDiferencial: ivaDiferencial,
          Exento: exento,
          ImpuestoInterno: impuestoInterno,
          TasaA: tasaA,
          PercepcionIb: percepcionIb
        });
        this.calcularTotal();
        setTimeout(() => {
          this.$refs.controlFocoNota.focus();
        }, 100);
      }
      this.loading = false;
    },
    calcularTotal() {
      this.itemActivo.Gravado = this.itemActivo.IvaBasico = this.itemActivo.IvaDiferencial = this.itemActivo.Exento = this.itemActivo.ImpuestoInterno = this.itemActivo.Total = this.itemActivo.TasaA = this.itemActivo.PercepcionIb = 0;
      this.itemActivo.Articulos.forEach(item => {
        this.itemActivo.Gravado += item.Gravado;
        this.itemActivo.IvaBasico += item.IvaBasico;
        this.itemActivo.IvaDiferencial += item.IvaDiferencial;
        this.itemActivo.Exento += item.Exento;
        this.itemActivo.ImpuestoInterno += item.ImpuestoInterno;
        this.itemActivo.TasaA += item.TasaA;
        this.itemActivo.PercepcionIb += item.PercepcionIb;
        this.itemActivo.Total += this.itemActivo.PercepcionIb;
        this.itemActivo.Total += item.Importe;
      });
      this.itemActivo.Total = Number(
        parseFloat(this.itemActivo.Total).toFixed(2)
      );
      if (this.esVentaContado) this.sugerirPagoEfectivo();
    },
    sugerirPagoEfectivo() {
      this.itemActivo.Pagos = [];
      this.agregarPago({
        NombreTipoPago: this.$nombreTipoPago_Efectivo,
        Importe: this.itemActivo.Total
      });
    },
    grillaBorrarItem_Pagos(item) {
      let ind = this.itemActivo.Pagos.findIndex(
        x => x.Id_TipoPago == item.Id_TipoPago
      );
      this.itemActivo.Pagos.splice(ind, 1);
      this.calcularTotalPago();
    },
    seleccionarTipoPago(nombre) {
      if (this.$refs.form1.validate()) {
        this.calcularTotalPago();
        if (this.itemActivo.TotalPagoPendiente > 0 || this.esOrdenPago) {
          switch (nombre) {
            case this.$nombreTipoPago_ChequePropio:
              this.modalTipoPagoChequePropioEjecutarAccion("Mostrar");
              break;
            case this.$nombreTipoPago_Transferencia:
              this.modalTipoPagoTransferenciaEjecutarAccion("Mostrar");
              break;
            default:
              this.modalTipoPagoEfectivoEjecutarAccion("Mostrar");
              break;
          }
        }
      }
    },
    modalTipoPagoEfectivoEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.modalTipoPagoEfectivoActivo = true;
          break;
        case "Aceptar":
          item.NombreTipoPago = this.$nombreTipoPago_Efectivo;
          this.agregarPago(item);
          this.modalTipoPagoEfectivoActivo = false;
          break;
        case "Cerrar":
          this.modalTipoPagoEfectivoActivo = false;
          break;
      }
    },
    modalTipoPagoChequePropioEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.modalTipoPagoChequePropio = true;
          break;
        case "Aceptar":
          item.NombreTipoPago = this.$nombreTipoPago_ChequePropio;
          this.agregarPago(item);
          this.modalTipoPagoChequePropio = false;
          break;
        case "Cerrar":
          this.modalTipoPagoChequePropio = false;
          break;
      }
    },
    modalTipoPagoTransferenciaEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.modalTipoPagoTransferenciaActivo = true;
          break;
        case "Aceptar":
          item.NombreTipoPago = this.$nombreTipoPago_Transferencia;
          this.agregarPago(item);
          this.modalTipoPagoTransferenciaActivo = false;
          break;
        case "Cerrar":
          this.modalTipoPagoTransferenciaActivo = false;
          break;
      }
    },
    agregarPago(item) {
      this.loading = true;
      if (item.Importe > 0) {
        let ind = this.itemsTipoPago.findIndex(
          x => x.Nombre == item.NombreTipoPago
        );
        item.Id_TipoPago = this.itemsTipoPago[ind].Id_TipoPago;
        switch (item.NombreTipoPago) {
          case this.$nombreTipoPago_ChequePropio:
            this.itemActivo.Pagos.push({
              Id_TipoPago: item.Id_TipoPago,
              NombreTipoPago: item.NombreTipoPago,
              Importe: item.Importe,
              Id_Chequera: item.Id_Chequera,
              Numero: item.Numero,
              FechaPago: item.FechaPago,
              Destinatario: item.Destinatario
            });
            break;
          case this.$nombreTipoPago_ChequeCartera:
            this.itemActivo.Pagos.push({
              Id_TipoPago: item.Id_TipoPago,
              NombreTipoPago: item.NombreTipoPago,
              Importe: item.Importe,
              Id_Banco: item.Id_Banco,
              NumeroChequeTercero: item.NumeroChequeTercero,
              FechaPago: item.FechaPago,
              Titular: item.Titular
            });
            break;
          default:
            this.itemActivo.Pagos.push({
              Id_TipoPago: item.Id_TipoPago,
              NombreTipoPago: item.NombreTipoPago,
              Importe: item.Importe
            });
        }
        this.calcularTotalPago();
      }
      this.loading = false;
    },
    calcularTotalPago() {
      this.itemActivo.TotalPago = 0;
      if (this.itemActivo.Pagos) {
        this.itemActivo.TotalPago = this.itemActivo.Pagos.map(
          item => item.Importe
        ).reduce((a, b) => a + b, 0);
        if (this.esOrdenPago) this.itemActivo.Total = this.itemActivo.TotalPago;
      }
      this.itemActivo.TotalPagoPendiente =
        this.itemActivo.Total - this.itemActivo.TotalPago;
    },
    validarPago() {
      let ok =
        this.itemActivo.TotalPago >= this.itemActivo.Total ||
        !this.esVentaContado;
      if (!ok)
        this.mostrarMensaje(
          true,
          "Aviso",
          null,
          "Debe completar la forma de pago."
        );
      return ok;
    },
    finalizar() {
      if (
        this.$refs.form1.validate() &&
        this.itemActivo.Total > 0 &&
        this.validarPago()
      )
        this.ejecutarAccion("Guardar");
    },
    guardarItem(item) {
      this.snackActivo = true;
      HttpHelper.post("Compra", item)
        .then(response => {
          if (this.esOrdenPago) this.imprimir(response.data);
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
        })
        .catch(error => {
          this.mostrarError(error);
        });
      setTimeout(() => {
        this.snackActivo = false;
      }, 2000);
    },
    imprimir(id) {
      HttpHelper.getBlob("Compra/Imprimir", {
        accion: "Imprimir",
        id: id
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      let detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
